import React from "react";
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { BsInfoCircle } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import GithubStats from "../Profile/GithubStats";
import app from "../../services/firebaseinit";
import { getShareInfo } from "../../services/shareSlice";
import "./quickshare.css";

const db = getFirestore(app);

const usersDb = "users";
const QuickShare = () => {
  const { shareProfile } = useSelector((state) => state.share);
  const dispatch = useDispatch();
  const params = useParams();
  const getShared = async () => {
    const { uid } = params;

    if (uid !== "") {
      try {
        onSnapshot(doc(db, usersDb, uid), (docucment) => {
          console.log(docucment);
          if (document !== null) {
            dispatch(getShareInfo(docucment.data()));
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };
  React.useEffect(() => {
    getShared();
  }, [0]);
  return (
    <div>
      <div className="flex w-full justify-center items-center">
        <div className="flex mf:flex-row flex-col items-start justify-between md:p-20 py-12 px-4">
          <div className="flex flex-1 justify-start items-start flex-col mf:mr-10">
            <h1 className="text-3xl sm:text-5xs text-white text-gradient p-3">{shareProfile && shareProfile?.name?.toUpperCase()}</h1>
            <p className="p-4">
              {shareProfile && <img className="w-full" src={`https://activity-graph.herokuapp.com/graph?username=${shareProfile.githubusername}&theme=dracula&color=B994E6&bg_color=2B2D3D`} />}
            </p>
          </div>
          <div className="flex flex-col mt-12 flex-1 items-center justify-start w-full mf:mt-0 mt-10">
            <div className="p-3 mt-12 flex justify-end items-start flex-col rounded-xl h-40 sm:w-72 w-full my-4 eth-card .white-glassmorphism ">
              {shareProfile && (
                <div className="flex justify-between flex-col w-full h-full">
                  <div className="flex justify-between items-start">
                    <div className="w-10 h-10 rounded-full border-2 border-white flex justify-center items-center">
                      <img src="https://avatars.githubusercontent.com/u/37832937?v=4" alt="" style={{ height: "35px", width: "35px", borderRadius: "50%" }} />
                    </div>
                    <BsInfoCircle fontSize={17} color="#fff" />
                  </div>
                  <div>
                    <p className="text-white font-light text-sm">
                      {params.uid}
                    </p>
                    <p className="text-white font-semibold text-lg mt-1">
                      {shareProfile?.name?.toUpperCase()}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {shareProfile && <GithubStats githubUsername={shareProfile?.githubusername} />}
    </div>
  );
};

export default QuickShare;
